module.exports = __webpack_public_path__ + "img/3-1.61f5033d.png";